// extracted by mini-css-extract-plugin
export var banner = "_r7-0";
export var settingRow = "_r7-2";
export var titleIcon = "_r7-1";